// extracted by mini-css-extract-plugin
export var cardHeader = "_sh-0";
export var reorderHandle = "_sh-3";
export var titleArea = "_sh-1";
export var titleAreaWithHandle = "_sh-2";